import React, { useEffect, useState, useCallback, useRef } from "react";
import axios, { AxiosRequestConfig } from "axios";
import {
  Tag,
  Space,
  Button,
  message,
  Image,
  Typography,
  Avatar,
  Tooltip,
  Modal,
  Input,
  Row,
  Col,
} from "antd";
import { helper } from "@src/controls/controlHelper";
import { Order } from "../types";
import { formatDateTime, formatMoney } from "../utils";
import styled from "styled-components";
import OrderDetail from "./OrderDetail";
import ProTable from "@src/packages/pro-table/Table";
import { ActionType, ProColumns, RequestData } from "@src/packages/pro-table";
import defaultRenderButton from "@src/controls/defaultRenderButton";
import { IButtonEditor } from "@src/controls/editors/ButtonEditor";
import ArraySelect from "@src/packages/pro-component/schema/ArraySelect";
import local from "@src/util/local";
import dayjs from "dayjs";
import {
  UserOutlined,
  QuestionCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
// import ChatDrawer from "./chat/ChatDrawer";
// import ChatDialog from "./chat/ChatDialog";
// import axios from "axios";
// import { connect } from "dva";

// Removed chat-related interfaces

const { Text } = Typography;

const ProductInfo = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  padding: 12px 0;
  width: 100%;
  max-width: 400px;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
    border-radius: 8px;
    padding: 12px;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    flex-wrap: wrap;
  }
`;

const ProductImage = styled(Image)`
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 8px;
  flex-shrink: 0;
  border: 1px solid #edf2f7;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const ProductDetails = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 576px) {
    width: 100%;
  }
`;

const ProductName = styled.div`
  font-weight: 500;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ProductVariation = styled(Text)`
  color: #666;
  font-size: 12px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// Removed unused styled component

// Removed unused styled component

// Removed unused styled component

const DeliveryInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  color: #666;
  font-size: 12px;
  min-width: 150px;

  @media (max-width: 576px) {
    align-items: flex-start;
    min-width: 100%;
  }
`;

const ShipCarrier = styled.div`
  color: #666;
  font-size: 12px;
  margin-bottom: 4px;
  font-weight: 500;
`;

const ShipService = styled.div`
  color: #666;
  font-size: 12px;
  margin-bottom: 4px;
`;

const ShipOrderCode = styled.div`
  color: #666;
  font-size: 12px;
`;

const OrderCode = styled.div`
  color: #666;
  font-size: 12px;
  margin-left: auto;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  flex-wrap: wrap;

  @media (max-width: 576px) {
    padding: 8px 0;
  }
`;

// Removed unused styled component

const statusColors = {
  pending: "#e6f7ff",
  processing: "#fff7e6",
  wait_for_confirmation: "#e6f7ff",
  confirmed: "#f6ffed",
  wait_for_pickup: "#fff7e6",
  shipping: "#e6f7ff",
  completed: "#f6ffed",
  canceled: "#fff1f0",
  refund: "#fff1f0",
  refunded: "#f5f5f5",
};

const statusTextColors = {
  pending: "#1890ff",
  processing: "#ff7f84",
  wait_for_confirmation: "#1890ff",
  confirmed: "#52c41a",
  wait_for_pickup: "#ff7f84",
  shipping: "#1890ff",
  completed: "#52c41a",
  canceled: "#f5222d",
  refund: "#f5222d",
  refunded: "#595959",
};

const StatusTag = styled(Tag)<{ $status: string }>`
  min-width: 120px;
  text-align: center;
  padding: 6px 16px;
  height: 32px;
  line-height: 20px;
  border-radius: 16px;
  font-weight: 500;
  font-size: 13px;
  background: ${(props) =>
    statusColors[props.$status as keyof typeof statusColors] || "#f0f0f0"};
  color: ${(props) =>
    statusTextColors[props.$status as keyof typeof statusTextColors] ||
    "#000000"};
  border: none;
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }
`;

const ActionButton = styled(Button)`
  margin: 0 4px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }

  &.ant-btn-primary {
    background: #9f60fc;
    border-color: #9f60fc;

    &:hover {
      background: #8c4fe3;
      border-color: #8c4fe3;
    }
  }

  &.ant-btn-dangerous {
    &:hover {
      background: #fff1f0;
      border-color: #ff4d4f;
    }
  }
`;

const ActionSpace = styled(Space)`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  .ant-btn {
    height: 32px;
    padding: 0 12px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s;

    &:hover {
      transform: translateY(-1px);
    }

    &.ant-btn-primary {
      background: #9f60fc;
      border-color: #9f60fc;

      &:hover {
        background: #ff6b4d;
        border-color: #ff6b4d;
      }
    }

    &.ant-btn-dangerous {
      &:hover {
        background: #fff1f0;
      }
    }
  }
`;

// Removed chat button styles

const renderOrderCell = (
  renderCell: (record: Order) => React.ReactNode,
): NonNullable<ProColumns<Order>["render"]> => {
  return (_, record) => {
    if (!record) {
      return null;
    }
    return renderCell(record);
  };
};

interface OrderTableProps {
  pageId: number;
  buildQueryParams: () => any;
  updatePagination: (current: number, pageSize: number) => void;
  title?: string;
  query?: any;
}

const OrderTable: React.FC<OrderTableProps> = ({
  pageId,
  buildQueryParams,
  updatePagination,
  title,
  query,
}) => {
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [detailVisible, setDetailVisible] = useState(false);
  const [cancelReason, setCancelReason] = useState("");
  const [pageInfo, setPageInfo] = useState<any>(null);
  const actionRef = useRef<ActionType>();
  const formRef = useRef<any>();
  const currentRequestParamsRef = useRef<Record<string, any>>({});
  // Removed chat-related states

  useEffect(() => {
    helper.getPage(pageId).then(setPageInfo);
  }, [pageId]);

  const tableTitle =
    title || query?.name || (pageInfo || {}).name || "Danh sách đơn hàng";

  const fetchOrders = useCallback(
    async (params: any): Promise<RequestData<Order>> => {
      try {
        setLoading(true);
        const currentPageInfo = pageInfo || (await helper.getPage(pageId));

        const response = await helper.callPageApi(
          currentPageInfo,
          "get-orders-ship",
          params,
        );

        const responseData = response as any;
        console.log("API Response:", responseData);

        // Kiểm tra response có đúng format không
        if (responseData?.status === 200 && responseData?.data?.code === 0) {
          // Set total from count
          setTotal(responseData.data.count || 0);
          return {
            data: responseData.data.data || [],
            success: true,
            total: responseData.data.count || 0,
          };
        }

        return {
          data: [],
          success: false,
          total: 0,
        };
      } catch (error) {
        console.error("Error fetching orders:", error);
        message.error("Không thể tải danh sách đơn hàng");
        return {
          data: [],
          success: false,
          total: 0,
        };
      } finally {
        setLoading(false);
      }
    },
    [pageId, pageInfo],
  );

  const handleConfirmOrder = async (
    id: number,
    status: "confirm" | "cancel",
    cancelReason?: string,
  ) => {
    try {
      const pageInfo = await helper.getPage(pageId);
      const response: any = await helper.callPageApi(
        pageInfo,
        "confirm-order",
        {
          orderShipId: id,
          status,
          cancelReason,
        },
      );
      console.log(response, "response");

      if (response?.data?.code === 0) {
        message.success(
          status === "confirm"
            ? "Xác nhận đơn hàng thành công"
            : "Hủy đơn hàng thành công",
        );
        // Refresh data
        actionRef.current?.reload();
      } else {
        message.error(
          response?.data?.err?.message ||
            response?.data?.message ||
            "Đã có lỗi xảy ra",
        );
      }
    } catch (error: any) {
      console.error("Error confirming order:", error);
      message.error(error?.message || "Đã có lỗi xảy ra");
    }
  };

  const showConfirmModal = (order: Order, action: "confirm" | "cancel") => {
    const title = action === "confirm" ? "Xác nhận đơn hàng" : "Hủy đơn hàng";
    const content =
      action === "confirm"
        ? "Bạn có chắc chắn muốn xác nhận đơn hàng này?"
        : "Bạn có chắc chắn muốn hủy đơn hàng này?";

    if (action === "cancel") {
      Modal.confirm({
        title,
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            <p>{content}</p>
            <Input.TextArea
              placeholder="Nhập lý do hủy"
              onChange={(e) => setCancelReason(e.target.value)}
              rows={3}
            />
          </div>
        ),
        okText: "Xác nhận",
        cancelText: "Đóng",
        onOk: () => handleConfirmOrder(order.id, "cancel", cancelReason),
      });
    } else {
      Modal.confirm({
        title,
        icon: <ExclamationCircleOutlined />,
        content,
        okText: "Xác nhận",
        cancelText: "Đóng",
        onOk: () => handleConfirmOrder(order.id, "confirm"),
      });
    }
  };

  const showOrderDetail = (order: Order) => {
    setSelectedOrder(order);
    setDetailVisible(true);
  };

  const getStatusText = (status: string) => {
    const statusMap: Record<string, string> = {
      pending: "Chờ xử lý",
      processing: "Đang xử lý",
      wait_for_confirmation: "Chờ xác nhận",
      confirmed: "Đã xác nhận",
      wait_for_pickup: "Chờ lấy hàng",
      shipping: "Đang giao hàng",
      completed: "Đã hoàn thành",
      canceled: "Đã hủy",
      refund: "Đang hoàn tiền",
      refunded: "Đã hoàn tiền",
    };
    return statusMap[status] || status;
  };

  const buildSearchQuery = (params: Record<string, any>) => {
    const queryInput: Record<string, any> = {};

    if (params.id) {
      queryInput.id = params.id;
    }

    if (params.paymentId) {
      queryInput.paymentId = params.paymentId;
    }

    if (params.deliveryName) {
      queryInput.deliveryName = { contains: params.deliveryName };
    }

    if (params.customerPhone) {
      queryInput.customerPhone = params.customerPhone;
    }

    const productFilterValue =
      Array.isArray(params.productId) && params.productId.length === 0
        ? params.product
        : params.productId ?? params.product;
    const selectedProductIds = Array.isArray(productFilterValue)
      ? productFilterValue
      : productFilterValue !== undefined && productFilterValue !== null
      ? [productFilterValue]
      : [];
    const productIds = selectedProductIds
      .map(Number)
      .filter((productId) => Number.isFinite(productId));

    if (productIds.length > 0) {
      // Contract with get-orders-ship: the backend resolves this virtual JSON
      // field through orderitem/ordership and intersects the matched order IDs.
      queryInput["orderItemInfos.productId"] = { in: productIds };
    }

    if (params.shipOrderCodeId) {
      queryInput.shipOrderCodeId = params.shipOrderCodeId;
    }

    if (params.paymentStatus) {
      queryInput.paymentStatus = params.paymentStatus;
    }

    if (params.invoiceStatus) {
      queryInput.invoiceStatus = params.invoiceStatus;
    }

    if (params.orderStatus && params.orderStatus !== "all") {
      switch (params.orderStatus) {
        case "wait_for_confirmation_group":
          queryInput.status = { in: ["wait_for_confirmation", "confirmed"] };
          break;
        case "refund_group":
          queryInput.status = { in: ["refund", "refunded"] };
          break;
        default:
          queryInput.status = params.orderStatus;
          break;
      }
    }

    if (
      Array.isArray(params.createdAtRange) &&
      params.createdAtRange.length === 2
    ) {
      queryInput.createdAt = {
        gte: dayjs(params.createdAtRange[0]).startOf("day").valueOf(),
        lte: dayjs(params.createdAtRange[1]).endOf("day").valueOf(),
      };
    }

    return queryInput;
  };

  const mergeQueryInput = (
    baseParams: any,
    searchQuery: Record<string, any>,
  ) => {
    const queryInput =
      typeof baseParams.queryInput === "string"
        ? JSON.parse(baseParams.queryInput || "{}")
        : baseParams.queryInput || {};

    return {
      ...baseParams,
      queryInput: JSON.stringify({
        ...queryInput,
        ...searchQuery,
      }),
    };
  };

  const parseApiOptionValue = (value: any) => {
    if (typeof value !== "string") return value;

    const trimmedValue = value.trim();
    if (trimmedValue === "true") return true;
    if (trimmedValue === "false") return false;
    if (trimmedValue === "null") return null;

    return value;
  };

  const getApiConfig = (apiName?: string) => {
    if (!pageInfo || !apiName) return null;
    return helper.getApiByName(pageInfo.apis || [], apiName);
  };

  const getApiOptionsPayload = (apiName?: string) => {
    const apiConfig = getApiConfig(apiName);
    if (!apiConfig || !Array.isArray(apiConfig.options)) return {};

    return apiConfig.options.reduce(
      (payload: Record<string, any>, option: any) => {
        if (!option || !option.key) return payload;

        payload[option.key] = parseApiOptionValue(option.value);
        return payload;
      },
      {},
    );
  };

  const buildApiUrl = (apiConfig: any) => {
    let url = apiConfig?.url || "";
    if (url.startsWith("/api/")) {
      url = url.substr(4, url.length - 1);
    }
    return url;
  };

  const getDownloadFileName = (headers: any, fallback: string) => {
    const disposition = headers?.["content-disposition"] || "";
    const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      const name = decodeURIComponent(utf8Match[1]).replace(/["']/g, "");
      return /\.[a-zA-Z0-9]{2,5}$/i.test(name) ? name : `${name}.xlsx`;
    }

    const fileNameMatch = disposition.match(/filename="?([^"]+)"?/i);
    if (fileNameMatch?.[1]) {
      const name = fileNameMatch[1].trim();
      return /\.[a-zA-Z0-9]{2,5}$/i.test(name) ? name : `${name}.xlsx`;
    }

    return fallback;
  };

  const downloadBlob = (data: any, headers: any, fallbackName: string) => {
    const contentType =
      headers?.["content-type"] ||
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const blob =
      data instanceof Blob ? data : new Blob([data], { type: contentType });
    const fileName = getDownloadFileName(headers, fallbackName);
    const downloadUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = downloadUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(downloadUrl);
  };

  const downloadApiResponse = async (
    apiConfig: any,
    payload: Record<string, any>,
    fallbackName: string,
  ) => {
    const method = (apiConfig.method || "GET").toUpperCase();
    const requestConfig: AxiosRequestConfig = {
      method,
      url: buildApiUrl(apiConfig),
      responseType: "blob",
      params: {
        page: pageInfo?.id,
        api: apiConfig.name,
        accesstoken: local.get("token") || "customer",
        ...(method === "GET" ? payload : {}),
      },
      data: method === "GET" ? undefined : payload,
      headers: {
        Authorization: `Bearer ${local.get("token")}`,
      },
    };

    const response = await axios(requestConfig);
    downloadBlob(response.data, response.headers, fallbackName);
  };

  const handleToolbarButtonClick = async (button: IButtonEditor) => {
    if (!pageInfo || !button.api) return;

    try {
      const apiConfig = getApiConfig(button.api);
      if (!apiConfig) {
        return message.warning("Không tìm thấy api");
      }

      const apiOptionsPayload = getApiOptionsPayload(button.api);
      const baseParams =
        currentRequestParamsRef.current &&
        Object.keys(currentRequestParamsRef.current).length > 0
          ? currentRequestParamsRef.current
          : buildQueryParams();
      const payload = {
        ...baseParams,
        ...apiOptionsPayload,
      };

      const isExportButton =
        button.mode === "export" ||
        button.action === "report" ||
        (button.action as string) === "export" ||
        button.title?.toLowerCase().includes("xuất") ||
        button.title?.toLowerCase().includes("export") ||
        button.api?.toLowerCase().includes("export") ||
        Boolean(
          apiConfig.downloadReport ||
            apiOptionsPayload.isExcel ||
            apiOptionsPayload.isExport,
        );

      if (isExportButton) {
        setExportLoading(true);

        const fallbackName =
          apiConfig.downloadReport ||
          `${pageInfo.name || apiConfig.name || "Danh sách đơn hàng"}.xlsx`;

        try {
          // 1. Thử gọi qua helper.callPageApi với responseType: "blob"
          try {
            const response: any = await helper.callPageApi(
              pageInfo,
              button.api,
              payload,
              { responseType: "blob" },
            );

            if (
              response?.data instanceof Blob &&
              response.data.type?.includes("application/json")
            ) {
              try {
                const text = await response.data.text();
                const json = JSON.parse(text);
                if (helper.tryDownloadExportPayload(json)) {
                  message.success("Xuất excel thành công");
                  return;
                }
                if (json?.message || json?.err?.message) {
                  message.error(json?.message || json?.err?.message);
                  return;
                }
              } catch {
                // continue
              }
            }

            const hasDownloaded =
              helper.tryDownloadExportResponse(response, fallbackName) ||
              helper.tryDownloadExportPayload(response?.data);

            if (hasDownloaded) {
              message.success("Xuất excel thành công");
              return;
            }

            if (response?.data instanceof Blob) {
              downloadBlob(response.data, response.headers, fallbackName);
              message.success("Xuất excel thành công");
              return;
            }
          } catch (callApiErr) {
            console.warn(
              "callPageApi export blob error, trying downloadApiResponse:",
              callApiErr,
            );
          }

          // 2. Dự phòng dùng axios trực tiếp nếu helper.callPageApi chưa tải được file
          await downloadApiResponse(apiConfig, payload, fallbackName);
          message.success("Xuất excel thành công");
          return;
        } catch (exportErr: any) {
          console.error("Export error:", exportErr);
          message.error(exportErr?.message || "Xuất file thất bại");
          return;
        } finally {
          setExportLoading(false);
        }
      }

      const response: any = await helper.callPageApi(
        pageInfo,
        button.api,
        payload,
      );

      if (response?.data?.code === 0 || response?.status === 200) {
        message.success(response?.data?.message || "Thành công");
        actionRef.current?.reload();
      } else {
        message.error(
          response?.data?.message ||
            response?.data?.err?.message ||
            "Đã có lỗi xảy ra",
        );
      }
    } catch (error: any) {
      console.error("Toolbar button error:", error);
      message.error(error?.message || "Đã có lỗi xảy ra");
    }
  };

  const toolBarRender = () => {
    const buttons = ((pageInfo || {}).buttons || [])
      .filter((button: IButtonEditor) => button.type !== "icon")
      .map((button: IButtonEditor, index: number) =>
        defaultRenderButton(
          button,
          {
            onClick: () => handleToolbarButtonClick(button),
          },
          `${button.mode || "toolbar"}-order-btn-${index}`,
        ),
      );

    return [...buttons];
  };

  // Removed chat-related functions

  const columns: ProColumns<Order>[] = [
    {
      title: "Id đơn hàng",
      dataIndex: "id",
      key: "id",
      hideInTable: true,
    },
    {
      title: "Id thanh toán",
      dataIndex: "paymentId",
      key: "paymentId",
      hideInTable: true,
    },
    {
      title: "SĐT mua hàng",
      dataIndex: "customerPhone",
      key: "customerPhone",
      hideInTable: true,
    },
    {
      title: "Mã vận chuyển",
      dataIndex: "shipOrderCodeId",
      key: "shipOrderCodeId",
      hideInTable: true,
    },
    {
      title: "Ngày tạo đơn",
      dataIndex: "createdAtRange",
      key: "createdAtRange",
      valueType: "dateRange",
      hideInTable: true,
    },
    {
      title: "Trạng thái đơn hàng",
      dataIndex: "orderStatus",
      key: "orderStatus",
      hideInTable: true,
      valueEnum: {
        all: "Tất cả",
        processing: "Đang xử lý",
        wait_for_confirmation: "Đang chờ xác nhận",
        wait_for_pickup: "Chờ lấy hàng",
        shipping: "Đang vận chuyển",
        completed: "Đã hoàn thành",
        canceled: "Đã hủy",
      },
    },
    {
      title: "Id thanh toán",
      key: "paymentId",
      align: "center" as const,
      hideInSearch: true,
      render: renderOrderCell((record: any) => {
        return record.paymentId ? record.paymentId : "-";
      }),
    },
    {
      title: "Trạng thái HĐĐT",
      key: "invoiceStatus",
      align: "center" as const,
      valueEnum: {
        pending: "Chưa xuất",
        processing: "Chờ xuất",
        completed: "Đã xuất",
        failed: "Thất bại",
        canceled: "Đã huỷ",
      },
      render: renderOrderCell((record: any) => {
        switch (record.invoiceStatus) {
          case "pending":
            return <Tag color="orange">Chưa xuất</Tag>;
          case "processing":
            return <Tag color="orange">Chờ xuất</Tag>;
          case "completed":
            return <Tag color="green">Đã xuất</Tag>;
          case "failed":
            return <Tag color="red">Thất bại</Tag>;
          case "canceled":
            return <Tag color="red">Đã huỷ</Tag>;
        }

        return <>-</>;
      }),
    },
    {
      title: "Số hoá đơn",
      key: "invoiceNo",
      align: "center" as const,
      hideInSearch: true,
      render: renderOrderCell((record: any) => {
        return record.invoiceNo ? record.invoiceNo : "-";
      }),
    },
    {
      title: "Ngày tạo đơn",
      dataIndex: "createdAt",
      key: "createdAt",
      align: "center" as const,
      hideInSearch: true,
      render: (value) => (
        <div data-label="Ngày tạo đơn">{formatDateTime(Number(value))}</div>
      ),
    },
    {
      title: "SĐT mua hàng",
      dataIndex: "customerPhone",
      key: "customerPhone",
      hideInSearch: true,
      align: "center" as const,
      render: renderOrderCell((record) => {
        return record?.customer?.phone ? record?.customer?.phone : "-";
      }),
    },
    {
      title: "Sản phẩm",
      dataIndex: "productId",
      key: "productId",
      renderFormItem: (_: any, { type, defaultRender, ...rest }: any) => {
        return (
          <ArraySelect
            type="checkbox"
            schema={{
              modelSelectField: "id,name",
              pageId: pageId || 117,
              api: "find-product",
            }}
            placeholder="Chọn sản phẩm"
            {...rest}
          />
        );
      },
      render: renderOrderCell((record) => (
        <div data-label="Sản phẩm">
          <UserInfo>
            <Avatar size="small" icon={<UserOutlined />} />
            <Text>{record.deliveryName}</Text>
            {/* Removed chat icon */}
            <OrderCode>Mã đơn: {record.id}</OrderCode>
          </UserInfo>
          {record.orderItemInfos?.map((item, index) => (
            <ProductInfo key={index}>
              <ProductImage src={item.images?.[0]} />
              <ProductDetails>
                <ProductName>{item.name}</ProductName>
                <ProductVariation>
                  {Array.isArray(item.attributeValues) &&
                  item.attributeValues.length > 0
                    ? item.attributeValues.map((attr, i) => (
                        <span key={i}>
                          {attr.type}: {attr.value}
                          {", "}
                        </span>
                      ))
                    : item.attributeValues
                    ? `${item.attributeValues}, `
                    : ""}
                  <span>x{item.quantity || 1}</span>
                </ProductVariation>
              </ProductDetails>
            </ProductInfo>
          ))}
        </div>
      )),
    },

    {
      title: "Tổng số đơn đặt hàng",
      dataIndex: "totalMoney",
      key: "totalMoney",
      align: "center" as const,
      hideInSearch: true,
      render: renderOrderCell((record) => {
        const totalQuantity =
          record.orderItemInfos?.reduce(
            (sum, item) => sum + (item.quantity || 0),
            0,
          ) || 0;
        return (
          <div data-label="Tổng tiền">
            <div>x{totalQuantity}</div>
            <div>{formatMoney(record.totalMoney)}</div>
          </div>
        );
      }),
    },
    {
      title: "Trạng thái",
      key: "status",
      align: "center" as const,
      hideInSearch: true,
      render: renderOrderCell((record) => (
        <div>
          <StatusTag $status={record.status}>
            {getStatusText(record.status)}
          </StatusTag>
          {record.status === "canceled" && record.cancelReason && (
            <Tooltip title={`Lý do hủy: ${record.cancelReason}`}>
              <QuestionCircleOutlined
                style={{ marginLeft: 4, color: "#8c8c8c" }}
              />
            </Tooltip>
          )}
        </div>
      )),
    },
    {
      title: "Đơn vị vận chuyển",
      key: "delivery",
      align: "center" as const,
      width: 150,
      hideInSearch: true,
      render: renderOrderCell((record) => (
        <DeliveryInfo>
          {record.shipCarrier && (
            <ShipCarrier>{record.shipCarrier}</ShipCarrier>
          )}
          {record.shipServiceName && (
            <ShipService>{record.shipServiceName}</ShipService>
          )}
          {record.shipOrderCodeId && (
            <ShipOrderCode>{record.shipOrderCodeId}</ShipOrderCode>
          )}
        </DeliveryInfo>
      )),
    },
    {
      title: "Phương thức thanh toán",
      key: "paymentMethodShip",
      align: "center" as const,
      width: 150,
      hideInSearch: true,
      render: renderOrderCell((record) => (
        <div>
          {record.paymentMethodShip === "cod" ? (
            <Tag color="green">COD</Tag>
          ) : (
            <Tag color="blue">Trực tuyến</Tag>
          )}
        </div>
      )),
    },
    {
      title: "Trạng thái thanh toán",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      align: "center" as const,
      width: 150,
      valueEnum: {
        pending: "Chờ thanh toán",
        success: "Đã thanh toán",
        failed: "Lỗi",
        canceled: "Hủy",
      },
      render: renderOrderCell((record) => {
        switch (record.paymentStatus) {
          case "pending":
            return <Tag color="blue">Chờ thanh toán</Tag>;
          case "success":
            return <Tag color="green">Đã thanh toán</Tag>;
          case "failed":
            return <Tag color="red">Lỗi</Tag>;
          case "canceled":
            return <Tag color="red">Hủy</Tag>;
          default:
            return <>-</>;
        }
      }),
    },
    {
      title: "Hành động",
      key: "action",
      align: "center" as const,
      valueType: "option",
      hideInSearch: true,
      render: renderOrderCell((record) => (
        <ActionSpace>
          <Button
            type="link"
            style={{ color: "#1890ff" }}
            onClick={() => showOrderDetail(record)}
          >
            Xem chi tiết
          </Button>
          {record.status === "wait_for_confirmation" && (
            <>
              <ActionButton
                type="primary"
                onClick={() => showConfirmModal(record, "confirm")}
              >
                Xác nhận
              </ActionButton>
              <ActionButton
                danger
                onClick={() => showConfirmModal(record, "cancel")}
              >
                Hủy
              </ActionButton>
            </>
          )}
          {record.status === "confirmed" && (
            <ActionButton
              danger
              onClick={() => showConfirmModal(record, "cancel")}
            >
              Hủy
            </ActionButton>
          )}
        </ActionSpace>
      )),
    },
  ];

  return (
    <Row>
      <Col md={24}>
        <ProTable<Order, any>
          actionRef={actionRef}
          formRef={formRef}
          type="table"
          tableClassName="gx-table-responsive"
          dateFormatter="number"
          headerTitle={tableTitle}
          columns={columns}
          loading={loading || exportLoading}
          rowKey="id"
          tableAlertRender={false}
          request={async (params) => {
            const { current = 1, pageSize = 10 } = params;
            const searchParams = { ...params };
            delete searchParams.current;
            delete searchParams.pageSize;
            delete searchParams._timestamp;
            updatePagination(current, pageSize);

            const baseParams = {
              ...buildQueryParams(),
              skip: (current - 1) * pageSize,
              limit: pageSize,
            };
            const searchQuery = buildSearchQuery(searchParams);
            const requestParams =
              Object.keys(searchQuery).length > 0
                ? mergeQueryInput(baseParams, searchQuery)
                : baseParams;
            currentRequestParamsRef.current = requestParams;

            return fetchOrders(requestParams);
          }}
          pagination={{
            total,
            showSizeChanger: true,
            // showTotal: (total) => `Total ${total} orders`,
            responsive: true,
            position: ["topRight", "bottomRight"],
            size: window.innerWidth <= 576 ? "small" : "default",
          }}
          toolBarRender={toolBarRender}
          scroll={{ x: "max-content" }}
        />

        <OrderDetail
          visible={detailVisible}
          order={selectedOrder}
          onClose={() => {
            setDetailVisible(false);
            setSelectedOrder(null);
          }}
        />
      </Col>
    </Row>
  );
};

export default OrderTable;
